import { TypedJsonResponse, useTypedFetcher, useTypedLoaderData } from "remix-typedjson";
import { ApiBindingsT } from "../route-helpers.server.ts";
export type { ApiBindingsT };

export function useBindings<
  T extends (
    ..._: any[]
  ) => Promise<TypedJsonResponse<{ bindings: Partial<ApiBindingsT> }>>,
>(...keys: (keyof ApiBindingsT)[]) {
  const ld = useTypedLoaderData<T>();

  for (const k of keys) {
    if (!ld.bindings[k]) {
      throw new Error(`expected useBindings() to provide \`${k}\``);
    }
  }

  type U = T extends (
    ..._: any[]
  ) => Promise<TypedJsonResponse<{ bindings: infer V }>> ? V
    : never;

  return ld.bindings as NonNullable<U>;
}

// use in conjunction with fetchers to provide type information outside of the regular remix server/client dataflow
// eg
// const { checkoutPreview } = fetcher.data.bindings as LoaderBindingsT<typeof checkoutPreviewLoader>;
export type LoaderBindingsT<Ld> = Ld extends
  (..._: any[]) => Promise<TypedJsonResponse<{ bindings: infer T }>> ? NonNullable<T>
  : never;
